import React from 'react';
import classNames from 'classnames';
import { trackFootfallEvent } from 'src/utils/analytics';
import footfallEventTypes from 'src/constants/footfallEventTypes';

const SearchLink = ({ url }) => {
  const searchLinkClasses = classNames({
    'icon-search-1': true,
    'solo-icon': true,
    'sitebar-link-search': true,
    'site-bar__heading': true,
    'site-bar__search-heading': true,
    'visible-xs': false,
    'visible-sm hidden-xs': true,
  });
  return (
    <a
      className={searchLinkClasses}
      href={url}
      onClick={() =>
        trackFootfallEvent(footfallEventTypes.CLICKED, { clickMetadata: {section: 'search-link'}, clickType: 'member-sitebar' })
      }
    />
  );
};

export default SearchLink;



// WEBPACK FOOTER //
// ./src/components/siteBar/searchLink.js